export default {
  production_provisions: (state) => state.production_provisions,
  combo_check: (state) => state.combo_check,
  combo_history: (state) => state.combo_history,
  ofa_history: (state) => state.ofa_history,
};
